import QRCodeImpl from 'qr.js/lib/QRCode'
import ErrorCorrectLevel from 'qr.js/lib/ErrorCorrectLevel'
import PropTypes from 'prop-types'
import React from 'react'
import QRCodeSvg from './QRCodeSVG'
export const QRCode = ({ level, size, value, ...props }) => {
  const qrCode = new QRCodeImpl(-1, ErrorCorrectLevel[level])
  qrCode.addData(value)
  qrCode.make()
  const cells = qrCode.modules
  return (
    <QRCodeSvg
      {...props}
      backgroundColor='white'
      bgD={cells
        .map((row, rowIndex) =>
          row.map((cell, cellIndex) => (!cell ? `M ${cellIndex} ${rowIndex} l 1 0 0 1 -1 0 Z` : '')).join(' ')
        )
        .join(' ')}
      color='black'
      fgD={cells
        .map((row, rowIndex) =>
          row.map((cell, cellIndex) => (cell ? `M ${cellIndex} ${rowIndex} l 1 0 0 1 -1 0 Z` : '')).join(' ')
        )
        .join(' ')}
      size={size}
      viewBoxSize={cells.length}
    />
  )
}

QRCode.displayName = 'QRCode'
QRCode.propTypes = {
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  value: PropTypes.string.isRequired,
}
QRCode.defaultProps = {
  level: 'L',
  size: 256,
}


export default QRCode